import * as yup from "yup";

export const DeductionsSetupValidationSchema = yup.object().shape({
  label: yup
  .string()
  .required("Deduction Label is required")
  .max(20, "Maximum length 20 characters"),
	maxYtd: yup
    .string()
    .max(99999999.99, "Maximum length 99999999.99 characters"),
});
